/**
 * Indicates what width the drawer should open as
 */
// eslint-disable-next-line import/prefer-default-export
export enum DrawerSize {
  // Standard width: 360px
  STANDARD = 'standard',
  // Wide width: 460px
  WIDE = 'wide',
}
